import { render } from "./bigFont.vue?vue&type=template&id=64e910f7&scoped=true"
import script from "./bigFont.vue?vue&type=script&lang=js"
export * from "./bigFont.vue?vue&type=script&lang=js"

import "./bigFont.vue?vue&type=style&index=0&id=64e910f7&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-64e910f7"

export default script